import { CategoriesProvider, CategoryModel } from '../../../../providers/categories/categories';
import { Injectable } from '@angular/core';
import { EventDetailsModel, EventProvider } from '../../../../providers/event/event';
import { StorageProvider } from '../../../../providers/storage-service/storage-service';
import { Cache } from '../../../../assets/data/cache-key/cache-key';

@Injectable()
export class EventDetailsResolver {
  constructor(
    private categoryService: CategoriesProvider,
    private eventService: EventProvider,
    private strg: StorageProvider) { }

  // its only resolves the categories, its good but it not enough,
  // you just dont dont have to implement router things its will be avaliable in ionic 4 now we using 3 but we want to change soon
  // so i just removed the router implementation, its was good btw
  // we dont want to use this currently in the live code, its just for prepare

  resolveIt(route: any, state: any): Promise<EventDetailsViewModel> {
    return (
      Promise.all([
        this.categoryService.getEventCategoires(),
        this.eventService.getEventDetails(route.somehowgetTheId) // we dont have to totaly implement it yet so its not problem if its not 100%
      ])
        .then(values => {
          return { categories: values[0], event: values[1] };
        })
        .catch(err => {
          console.log('[ TODO ] implement error handing for data resolvers', err);
          /// if the catch triggers we also have to return to continue the flow
          return { categories: [], event: null };
        })
    );
  }

  //TODO: interface for instead of any
  preloadMap(lid: string): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      if (!navigator.onLine) { this.strg.getSaved(Cache.PRELOAD_MAP + lid).then(r => resolve(r)).catch(e => reject(e)); }
      else {
        // this.eventService.getMapbyLid(lid)
        //   .then(result => {
        //     this.strg.saveData(result, Cache.PRELOAD_MAP + lid);
        //     resolve(result);
        //   })
        //   .catch(err => reject(err));
      }
    });
  }

}


// Here you just create a model for the view what you want to resolve
// export means its public in file scope, so you can use it in other files
export interface EventDetailsViewModel {
  event: EventDetailsModel;
  categories: CategoryModel[];
}
